export default "__VITE_ASSET__CFswZvu___"